import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { AuthService } from '../../../core';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule]
})
export class NavigationComponent {
  private readonly router = inject(Router);
  protected readonly authService = inject(AuthService);

  protected readonly hasTechAdminRole = this.authService.isTechAdmin;
  protected readonly hasAdminRole = this.authService.isAdmin;

  private readonly urlPath = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(() => this.router.url),
      startWith(this.router.url)
    ),
    { initialValue: this.router.url }
  );

  /** Public onboarding invite pages should not show app nav tabs. */
  protected readonly isOnboardingShell = computed(() =>
    (this.urlPath() ?? '').startsWith('/onboarding')
  );
}
